// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
import type { ITheme } from "@fluentui/react/lib/Styling";
import { concatStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { StandardControlSemanticColors } from "@1js/acui-common";
import { getStandardControlSemanticColorsWithTheme } from "@1js/acui-common";
import type { AppGalleryStyles } from "@1js/acui-gallery";
import { isNextStyleEnabled } from "@1js/acui-theme";

const galleryButtonHeight = 34;
const nextStyleHeight = 30;

const previewGalleryButtonStyles = memoizeFunction(
  (theme: ITheme): IButtonStyles => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    return {
      root: {
        boxSizing: "border-box",
        height: isNextStyleEnabled() ? nextStyleHeight : galleryButtonHeight,
        minWidth: 40,
        width: "auto",
        paddingLeft: 4,
        paddingRight: 4,
        selectors: {
          ":focus": {
            borderColor: standardControlSemanticColors.galleryHoverFocusColor,
          },
          i: {
            margin: 0,
          },
        },
      },
      flexContainer: {
        margin: 0,
        lineHeight: "normal",
      },
    };
  }
);

const previewExpandButtonStyles: IButtonStyles = {
  root: {
    height: galleryButtonHeight,
    borderTop: "none",
    borderBottom: "none",
  },
};

const previewExpandButtonStylesNext: IButtonStyles = {
  root: {
    height: nextStyleHeight,
  },
};

/**
 * Get the styling for the preview gallery
 * @param { Partial<AppGalleryStyles> } customStyles - Optional, custom styles to apply to gallery
 */
export const getIconPreviewGalleryStyles = memoizeFunction(
  (
    theme: ITheme,
    customStyles?: Partial<AppGalleryStyles>
  ): Partial<AppGalleryStyles> => {
    const galleryContainer = customStyles?.galleryContainer;
    const previewStackStyle = customStyles && customStyles.previewStackStyle;
    const previewExpandButton = concatStyleSets(
      previewExpandButtonStyles,
      isNextStyleEnabled() && previewExpandButtonStylesNext,
      customStyles && customStyles.previewExpandButton
    );
    return {
      galleryContainer,
      previewExpandButton,
      previewStackStyle,
      galleryButtonInPreview: concatStyleSets(
        previewGalleryButtonStyles(theme),
        customStyles && customStyles.galleryButtonInPreview
      ),
    };
  }
);
